// extracted by mini-css-extract-plugin
module.exports = {"voice":"index-module_voice_1NBOt","playing":"index-module_playing_2ltDt"};